import type { TokenDetails, Token } from "@/shared/types/common.types";
import api from "./apiClient";

export const authService = {
  login: (data: any): Promise<any> => api.post("/auth/login", data).then((res) => res.data),
  getToken: (Payload: TokenDetails): Promise<Token> => api.post("auth/sessions", Payload).then((res) => res.data),
  // Exchanges the refresh_token cookie for a new jwt + refresh_token pair without re-entering credentials.
  refreshSession: (): Promise<Token> => api.post("auth/sessions/refresh").then((res) => res.data),
  logout: (): Promise<void> => api.delete("auth/sessions").then(() => {}),
};